import { render, staticRenderFns } from "./IdentiteitCardsResults.vue?vue&type=template&id=021a630a&scoped=true&"
import script from "./IdentiteitCardsResults.vue?vue&type=script&lang=js&"
export * from "./IdentiteitCardsResults.vue?vue&type=script&lang=js&"
import style0 from "./IdentiteitCardsResults.vue?vue&type=style&index=0&id=021a630a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a630a",
  null
  
)

export default component.exports